import MatchingProcess from "../../components/MatchingProcess";

const MatchingProcessPage = () => {
  return (
    <MatchingProcess/>
  );
};

export default MatchingProcessPage;
